import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.capstone');
import { HostListener, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-capstone',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.capstone/view.scss */
:host {
  display: block;
  min-height: 100%;
  width: 100%;
}

[contenteditable=true]:hover, [contenteditable=true]:focus {
  background: rgba(55, 53, 47, 0.035);
  border-radius: 0;
}

article {
  min-height: 118px;
}

[role=tabpanel] > main {
  width: 100%;
  max-width: none !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-left: clamp(24px, 4vw, 56px) !important;
  padding-right: clamp(24px, 4vw, 56px) !important;
}

[class*=rounded] {
  border-radius: 0 !important;
}

[role=tabpanel][hidden] {
  display: none !important;
}

.oral-training-frame {
  display: block;
  width: 100%;
  border: 0;
  background: #f4f8fb;
}`],
})
export class PageCapstoneComponent implements OnInit, OnDestroy {
    public sectionView: string = new URLSearchParams(location.search).get('section') === 'implementation' ? 'implementation' : 'description';
    public projectTitle: string = '캡스톤디자인';
    public selectedView: string = 'board';
    public newTask: any = { title: '', status: 'todo' };
    public savedMessage: string = '';
    public milestones: any[] = [
        { title: '주제 제안 및 팀 빌딩', date: '09.12', done: true },
        { title: '요구사항 정의', date: '09.26', done: true },
        { title: '프로토타입 시연', date: '10.24', done: false },
        { title: '최종 발표 및 결과물 제출', date: '12.05', done: false }
    ];
    public columns: any[] = [
        {
            id: 'todo', title: '할 일', color: 'bg-gray-400',
            tasks: [
                { title: '사용자 인터뷰 질문지 작성', owner: '민주', tag: '리서치', due: '10.09' },
                { title: '서비스 플로우 정리', owner: '서준', tag: '기획', due: '10.11' }
            ]
        },
        {
            id: 'doing', title: '진행 중', color: 'bg-amber-400',
            tasks: [
                { title: '모바일 와이어프레임 제작', owner: '하린', tag: '디자인', due: '10.08' },
                { title: 'API 명세 초안', owner: '도윤', tag: '개발', due: '10.10' }
            ]
        },
        {
            id: 'done', title: '완료', color: 'bg-emerald-500',
            tasks: [
                { title: '페르소나 및 문제 정의', owner: '팀', tag: '기획', due: '10.02' }
            ]
        }
    ];

    private pageSubscription: any;
    private pageLocation = '';
    private defaults: any;
    private pageGeneration = 0;
    public pageState: any = null;
    public canEdit = false;
    public pageBusy = false;
    public pageError = '';
        private async pageRequest(action: string, data: any = {}) {
        const response: any = await wiz.app('component.page.share').call('handle', { action, data: JSON.stringify(data) });
        if (response.code !== 200) throw new Error(response.data?.message || response.message || '페이지를 불러오지 못했습니다.');
        return response.data;
    }

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        this.defaults = JSON.parse(JSON.stringify({projectTitle: this.projectTitle, milestones: this.milestones, columns: this.columns}));
        this.pageLocation = location.href;
        this.pageSubscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd && location.href !== this.pageLocation) {
                this.pageLocation = location.href;
                this.sectionView = new URLSearchParams(location.search).get('section') === 'implementation' ? 'implementation' : 'description';
                Object.assign(this, JSON.parse(JSON.stringify(this.defaults)));
                void this.loadPage().then(() => this.service.render());
            }
        });
        await this.loadPage();
        await this.service.render();
    }

    public async loadPage() {
        const generation = ++this.pageGeneration;
        this.canEdit = false;
        this.pageState = null;
        this.pageError = '';
        if (!this.service.auth.status) return;
        try {
            const state = await this.pageRequest('get', {path: '/capstone', id: new URLSearchParams(location.search).get('share') || ''});
            if (generation !== this.pageGeneration) return;
            this.pageState = state;
            let data = this.pageState.content;
            if (this.pageState.role === 'owner' && this.pageState.version === 0) {
                try { data = JSON.parse(localStorage.getItem('ku-capstone-page') || 'null') || data; } catch {}
            }
            this.projectTitle = data.projectTitle || this.projectTitle;
            if (Array.isArray(data.milestones)) this.milestones = data.milestones;
            if (Array.isArray(data.columns)) this.columns = data.columns;
            this.canEdit = this.pageState.role !== 'viewer';
            if (this.pageState.role === 'owner' && this.pageState.version === 0) {
                await this.save();
                if (!this.pageError) localStorage.removeItem('ku-capstone-page');
            }
        } catch (error: any) { this.pageError = error.message; this.canEdit = false; }
    }
    public async save() {
        if (!this.canEdit || this.pageBusy) return;
        this.pageBusy = true;
        try {
            this.pageState = await this.pageRequest('save', {id: this.pageState.id, path: '/capstone',
                version: this.pageState.version, content: {projectTitle: this.projectTitle, milestones: this.milestones, columns: this.columns}});
            this.savedMessage = '서버에 저장됨';
            this.pageError = '';
        } catch (error: any) { this.pageError = error.message; this.canEdit = false; }
        finally { this.pageBusy = false; await this.service.render(); }
    }

    public async updateTitle(event: any) {
        if (!this.canEdit || this.pageBusy) return;
        this.projectTitle = event.target.innerText.trim() || '캡스톤디자인';
        await this.save();
        await this.service.render();
    }

    @HostListener('window:ku-capstone-section', ['$event'])
    public onSectionChange(event: CustomEvent<string>) {
        void this.setSection(event.detail);
    }

    public async setSection(section: string, focus: boolean = false, event?: KeyboardEvent) {
        event?.preventDefault();
        if (section !== 'description' && section !== 'implementation') return;
        this.sectionView = section;
        await this.service.render();
        if (focus) document.getElementById('capstone-tab-' + section)?.focus();
    }

    public async setView(view: string) {
        this.selectedView = view;
        await this.service.render();
    }

    public async toggleMilestone(item: any) {
        if (!this.canEdit || this.pageBusy) return;
        item.done = !item.done;
        await this.save();
        await this.service.render();
    }

    public async addTask() {
        if (!this.canEdit || this.pageBusy) return;
        const value = this.newTask.title.trim();
        if (!value) return;
        const column = this.columns.find((item: any) => item.id === this.newTask.status) || this.columns[0];
        column.tasks.unshift({ title: value, owner: '나', tag: '새 업무', due: '미정' });
        this.newTask.title = '';
        await this.save();
        await this.service.render();
    }

    public async moveTask(columnIndex: number, taskIndex: number) {
        if (!this.canEdit || this.pageBusy) return;
        const task = this.columns[columnIndex].tasks.splice(taskIndex, 1)[0];
        const nextIndex = Math.min(columnIndex + 1, this.columns.length - 1);
        this.columns[nextIndex].tasks.unshift(task);
        await this.save();
        await this.service.render();
    }

    public trainingFrameHeight = 1100;
    @HostListener('window:message', ['$event'])
    public async onTrainingFrameSize(event: MessageEvent) {
        const frame = document.getElementById('oralTrainingApp') as HTMLIFrameElement | null;
        if (event.origin !== location.origin || event.source !== frame?.contentWindow) return;
        if (event.data?.type !== 'oral-training-height' || !Number.isFinite(event.data.height)) return;
        this.trainingFrameHeight = Math.max(600, Math.min(6000, event.data.height));
        await this.service.render();
    }

    public ngOnDestroy() {
        this.pageGeneration++;
        this.pageSubscription?.unsubscribe();
    }
}

export default PageCapstoneComponent;